import { GridColDef } from "@mui/x-data-grid-pro";
import { ArticleBrandId, ArticleCategory } from "entities/manageArticles/types";
import { generatePath, NavigateFunction } from "react-router-dom";
import DropdownList from "shared/components/DropdownList";
import { MANAGE_ARTICLES_GROUP_PATH } from "shared/routes/paths";
import { FolderIcon } from "shared/theme/icons/FolderIcon";
import { formatUpdatedAt } from "shared/utils/formatUpdatedAt";

export const getArticlesColumns = (
  brandId: ArticleBrandId,
  categoryId: ArticleCategory,
  navigate: NavigateFunction,
): GridColDef[] => {
  return [
    {
      field: "id",
      editable: false,
      flex: 0.1,
      sortable: false,
      renderCell: FolderIcon,
      headerName: "",
    },
    {
      field: "name",
      headerName: "Title",
      editable: false,
      flex: 0.5,
    },
    {
      field: "languages",
      headerName: "Language(s)",
      editable: false,
      sortable: false,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) =>
        params.value
          ?.map((language: string) => language.toUpperCase())
          .join(", "),
    },
    {
      field: "updatedAt",
      headerName: "Updated at",
      editable: false,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => formatUpdatedAt(params.value),
    },
    {
      field: "actions",
      headerName: "",
      sortable: false,
      editable: false,
      align: "right",
      headerAlign: "right",
      flex: 0.5,
      renderCell: (params) => (
        <DropdownList
          items={[
            {
              title: "Open",
              onClick: () => {
                navigate(
                  generatePath(MANAGE_ARTICLES_GROUP_PATH, {
                    brandId,
                    categoryId,
                    groupId: params.row.id,
                  }),
                );
              },
            },
          ]}
        />
      ),
    },
  ];
};
